









import {Component, Vue} from 'vue-property-decorator';
import {FeathersVuexFindAll} from '@/utils';
import ServicesPage from '@/components/Pages/Home Page/Services/ServicesPage.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';

@Component({
    components: {
        HeroImage,
        ServicesPage,
    },
})
export default class ServicesHair extends Vue {
    private header = 'Hair Services';
    private hero1 = 'Pick a hair style. Date & Time. Get Ready';
    private hero2 = 'Book from our full suit of services below';
    private heroImage = require('@/assets/hero/hair.jpg');
    private title = 'GET THE LOOK YOU\'VE BEEN WAITING FOR...';
    private crumbs = [
        {name: 'Home', path: '/'},
        {name: 'Services', path: '/services'},
        {name: 'Hair Services', path: '/services/hair-services'},
    ];
    public serviceQuery = null;
    public mounted() {
        this.setServiceQuery();
    }
    public async setServiceQuery() {
        const {ServiceType, Category} = this.$FeathersVuex;
        const serviceTypes = await FeathersVuexFindAll(ServiceType, {
            query: {
                name: 'Hair',
            },
        });
        const [category] = await FeathersVuexFindAll(Category, {
            query: {
                name: 'Personal',
            },
        });
        this.serviceQuery = {
            serviceTypes: {$in: serviceTypes.map((x) => x._id)},
            category: category._id,
            $sort: {
                displayOrder: 1,
            },
        };
    }

}
